import { deleteRequest, getRequest, postRequest, putRequest } from "api/axiosClient";
import { BaseParamsRequest } from "api/request/basParams.request";
import {
  GetCompanyContactBookRequestParams,
  GetCompanyAddressBookRequestParams,
  GetCompanyAddressV2BookRequestParams,
  GetCompanyUserParams,
  GetCompaniesResponseParams,
} from "../request";
import {
  GetCompanyUserResponseType,
  GetCompaniesResponseType,
  GetCompanyAddressBookResponseType,
  GetCompanyAddressV2BookResponseType,
  GetCompanyContactBookResponseType,
  CreateUpdateCompanyAddressV2ResponseType,
} from "../response";

const { REACT_APP_CARGOBASE_BASE_URL } = import.meta.env;
const baseURL = `${REACT_APP_CARGOBASE_BASE_URL}/company`;

const getCompanies = (params: BaseParamsRequest<GetCompaniesResponseParams>) =>
  getRequest<GetCompaniesResponseType>(`${baseURL}`, params);

const getCompanyAddressBook = (params: BaseParamsRequest<GetCompanyAddressV2BookRequestParams>) =>
  getRequest<GetCompanyAddressBookResponseType>(`${baseURL}/address-book`, params);

const getCompanyAddressV2Book = (params: BaseParamsRequest<GetCompanyAddressBookRequestParams>) =>
  getRequest<GetCompanyAddressV2BookResponseType>(`${baseURL}/address`, params);

const getCompanyAddressV2Details = (reference_number: string) =>
  getRequest<GetCompanyAddressV2BookResponseType>(`${baseURL}/address/${reference_number}`);

const getCompanyContactBook = (params: BaseParamsRequest<GetCompanyContactBookRequestParams>) =>
  getRequest<GetCompanyContactBookResponseType>(`${baseURL}/contact-book`, params);

const getCompanyUsers = (params: BaseParamsRequest<GetCompanyUserParams>) =>
  getRequest<GetCompanyUserResponseType>(`${baseURL}/users`, params);

const addCompanyAddress = (payload: any) =>
  postRequest<CreateUpdateCompanyAddressV2ResponseType>(`${baseURL}/address`, payload);

const updateCompanyAddress = (reference_number: string, payload: any) =>
  putRequest<CreateUpdateCompanyAddressV2ResponseType>(`${baseURL}/address/${reference_number}`, payload);

const deleteCompanyAddress = (reference_number: string) => deleteRequest(`${baseURL}/address/${reference_number}`);

export {
  getCompanies,
  getCompanyAddressBook,
  getCompanyAddressV2Book,
  getCompanyAddressV2Details,
  getCompanyContactBook,
  getCompanyUsers,
  addCompanyAddress,
  updateCompanyAddress,
  deleteCompanyAddress,
};
